/* DRW-76: Mobile dots indicator for horizontal Swiper carousels.
   Hooks onto existing Swiper instances (created by theme.js Carousel helper)
   without re-initializing them. Mobile-only via CSS in custom.css.
   Renders one <span> per snap position; updates active state on slideChange. */
(function () {
  if (window.__drwMobileDotsInit) return;
  window.__drwMobileDotsInit = true;

  function build(container, count) {
    container.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('span');
      dot.className = 'drw-mobile-dots__dot';
      container.appendChild(dot);
    }
  }

  function setActive(container, index) {
    var dots = container.querySelectorAll('.drw-mobile-dots__dot');
    for (var i = 0; i < dots.length; i++) {
      if (i === index) {
        dots[i].classList.add('drw-mobile-dots__dot--active');
      } else {
        dots[i].classList.remove('drw-mobile-dots__dot--active');
      }
    }
  }

  function setupInstance(dotsEl) {
    var swiperEl = dotsEl.previousElementSibling;
    if (!swiperEl || !swiperEl.classList.contains('swiper')) return;

    var tries = 0;
    function tryBind() {
      var sw = swiperEl.swiper;
      if (!sw) {
        if (++tries > 100) return; // give up after ~10s
        setTimeout(tryBind, 100);
        return;
      }

      function refresh() {
        var count = sw.snapGrid ? sw.snapGrid.length : 0;
        if (count <= 1) {
          dotsEl.classList.add('drw-mobile-dots--hidden');
          dotsEl.innerHTML = '';
          return;
        }
        dotsEl.classList.remove('drw-mobile-dots--hidden');
        build(dotsEl, count);
        setActive(dotsEl, sw.snapIndex || 0);
      }

      function syncActive() {
        setActive(dotsEl, sw.snapIndex || 0);
      }

      sw.on('snapGridLengthChange', refresh);
      sw.on('breakpoint', refresh);
      sw.on('slideChange', syncActive);
      sw.on('snapIndexChange', syncActive);

      refresh();
    }
    tryBind();
  }

  function init() {
    var els = document.querySelectorAll('[data-drw-mobile-dots]');
    for (var i = 0; i < els.length; i++) setupInstance(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
